module.exports = __webpack_public_path__ + "img/glassquality_2.a91c2a1b.png";